import './src/styles/global.css'

import React from "react";
import { TranslationProvider } from "./src/i18n/TranslationContext";

export const wrapPageElement = ({ element, props }) => {
  const { pageContext = {} } = props;
  const {
    lang = "en",
    dir = "ltr",
    prefix = "",
    translations = {},
    originalPath = "/",
    alternateUrls = [],
  } = pageContext;

  return (
    <TranslationProvider
      lang={lang}
      dir={dir}
      prefix={prefix}
      translations={translations}
      originalPath={originalPath}
      alternateUrls={alternateUrls}
    >
      {element}
    </TranslationProvider>
  );
};